import type { PostHog } from "@posthog/react";
import type { Uuid } from "spacetimedb";

export const PosthogEvents = {
  BankAccountConnected(posthog: PostHog, underwritableEntityId: Uuid) {
    posthog.capture("bank_account_connected", {
      underwritableEntityId: underwritableEntityId.toString(),
    });
  },
  PosConnected(posthog: PostHog, underwritableEntityId: Uuid) {
    posthog.capture("pos_connected", { underwritableEntityId: underwritableEntityId.toString() });
  },
  QuickbooksConnected(posthog: PostHog, underwritableEntityId: Uuid) {
    posthog.capture("quickbooks_connected", {
      underwritableEntityId: underwritableEntityId.toString(),
    });
  },
  LeaseDocumentUploaded(posthog: PostHog, underwritableEntityId: Uuid) {
    posthog.capture("lease_document_uploaded", {
      underwritableEntityId: underwritableEntityId.toString(),
    });
  },
  TaxReturnUploaded(posthog: PostHog, underwritableEntityId: Uuid) {
    posthog.capture("tax_return_uploaded", {
      underwritableEntityId: underwritableEntityId.toString(),
    });
  },
  LandlordInvited(posthog: PostHog, underwritableEntityId: Uuid) {
    posthog.capture("landlord_invited", {
      underwritableEntityId: underwritableEntityId.toString(),
    });
  },
};
